var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconfinderAmongUsGhost7142959(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "etc"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "knife"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "emergency_meeting"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Suspicious"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "report"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "killed"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Die_1_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Pets"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Vent"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Die_2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "ghost"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,11c0-1.424-0.6055-2.703-1.564-3.6146c-0.0118-0.1018-0.0261-0.2043-0.0712-0.3024C26.2261,4.6025,23.728,3,21,3h-4   c-3.8599,0-7,3.1401-7,7H9c-1.6543,0-3,1.3457-3,3v8c0,1.5166,1.1348,2.7605,2.5978,2.9594C8.3992,23.9852,8.1965,24,8,24H7   c-0.9229,0-2-0.2617-2-1c0-0.5522-0.4478-1-1-1s-1,0.4478-1,1c0,3.7944,3.2056,7,7,7h3c1.2061,0,3-0.7988,3-3v-2   c0-0.5513,0.4487-1,1-1s1,0.4487,1,1v2c0,1.6543,1.3457,3,3,3s3-1.3457,3-3v-4c0-0.5513,0.4487-1,1-1s1,0.4487,1,1   c0,0.5522,0.4478,1,1,1s1-0.4478,1-1v-9c0-0.0088-0.0048-0.0161-0.005-0.0248C28.6179,13.1413,29,12.1183,29,11z M8,21v-8   c0-0.5513,0.4487-1,1-1h1v9v1H9C8.4487,22,8,21.5513,8,21z M26,20.1843C25.6857,20.0722,25.3524,20,25,20c-1.6543,0-3,1.3457-3,3v4   c0,0.5513-0.4487,1-1,1s-1-0.4487-1-1v-2c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3v2c0,0.8052-0.5503,0.9883-1,1h-3   c-1.6261,0-3.0895-0.8332-4.0091-2.0778C6.3024,25.9709,6.6362,26,7,26h1c2.7632,0,4-1.5068,4-3v-2V11v-1c0-2.7568,2.2432-5,5-5h4   c1.0934,0,2.1282,0.3705,2.9759,1H20c-2.7568,0-5,2.2432-5,5s2.2432,5,5,5h4c0.7118,0,1.3864-0.1545,2-0.4238V20.1843z M24,14h-4   c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3h4c1.6543,0,3,1.3457,3,3S25.6543,14,24,14z M26,10c0,0.5522-0.4477,1-1,1s-1-0.4478-1-1   c0-0.5523,0.4477-1,1-1S26,9.4477,26,10z M23,10c0,0.5522-0.4478,1-1,1h-2c-0.5522,0-1-0.4478-1-1s0.4478-1,1-1h2   C22.5522,9,23,9.4478,23,10z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Hats"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Crewmates"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "ejection"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "sabotage"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Die"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "impostor"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "pets"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "crewmates"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfinderAmongUsGhost7142959);
export default __webpack_public_path__ + "static/media/iconfinder_Among_Us_ghost_7142959.df77bdffa55b69df225e7aa202b7e295.svg";
export { ForwardRef as ReactComponent };